export default __webpack_public_path__ + "static/media/banners.e510795d.md";